import React from "react";
import DefaultBlock from "../components/main/DefaultBlock";
import { Typography } from "@mui/material";
import { Button, Box } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import BlueprintBlock from "../components/main/BlueprintBlock";
import SEO from "../components/misc/SEO";

import BlogColumn from "../components/main/BlogColumn";

export default function Contact() {
  return (
    <div>
      <SEO
        title="Contact Me | Aaron Hunt"
        description="Get in touch! I want to hear from you. Let's work together and make something awesome!"
      />
      <BlueprintBlock
        text="HTTP GET ::
content-type: in-touch {
"
      />
      <DefaultBlock id="work-examples">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Box sx={{ mb: 16, maxWidth: "602px" }}>
            <Typography
              variant="h3"
              sx={{ p: 2, maxWidth: "512px", opacity: 0.8, mt: 6 }}
            >
              Get in Touch
            </Typography>
            <Typography variant="body1" sx={{ p: 2, opacity: 0.8 }}>
              Let's get in contact! My email is anhuntz [at] gmail [dot] com.
            </Typography>

            <Button
              variant="contained"
              color="primary"
              href="https://gmail.com/"
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<LaunchIcon />}
              sx={{ m: 2 }}
            >
              Email Me
            </Button>
          </Box>
        </Box>

        <Box className="backgroundGrid">
          <BlogColumn showProjects={true} limit={5} />
        </Box>
      </DefaultBlock>
    </div>
  );
}
